import { useCallback, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSupplierOnlineShopListQuery } from 'api';

export const useOnlineShop = () => {
  const [onlineShopId, setOnlineShopId] = useState<string | undefined>(undefined);
  const { id } = useParams() as { id: string };
  const { data = [] } = useSupplierOnlineShopListQuery({ id });
  const onDeleteModalStateChange = useCallback((id?: string) => {
    setOnlineShopId(id);
  }, []);
  return {
    onDeleteModalStateChange,
    onlineShopId,
    data,
  };
};
